/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var FxIdDomainSettingsPublicWebClientConfigOptionsDiagType;
(function (FxIdDomainSettingsPublicWebClientConfigOptionsDiagType) {
    FxIdDomainSettingsPublicWebClientConfigOptionsDiagType[FxIdDomainSettingsPublicWebClientConfigOptionsDiagType["PortCheck"] = 1] = "PortCheck";
    FxIdDomainSettingsPublicWebClientConfigOptionsDiagType[FxIdDomainSettingsPublicWebClientConfigOptionsDiagType["Ping"] = 2] = "Ping";
    FxIdDomainSettingsPublicWebClientConfigOptionsDiagType[FxIdDomainSettingsPublicWebClientConfigOptionsDiagType["TraceRoute"] = 3] = "TraceRoute";
    FxIdDomainSettingsPublicWebClientConfigOptionsDiagType[FxIdDomainSettingsPublicWebClientConfigOptionsDiagType["MSInfo"] = 4] = "MSInfo";
    FxIdDomainSettingsPublicWebClientConfigOptionsDiagType[FxIdDomainSettingsPublicWebClientConfigOptionsDiagType["DXDiag"] = 5] = "DXDiag";
    FxIdDomainSettingsPublicWebClientConfigOptionsDiagType[FxIdDomainSettingsPublicWebClientConfigOptionsDiagType["ProcessList"] = 6] = "ProcessList";
    FxIdDomainSettingsPublicWebClientConfigOptionsDiagType[FxIdDomainSettingsPublicWebClientConfigOptionsDiagType["File"] = 7] = "File";
    FxIdDomainSettingsPublicWebClientConfigOptionsDiagType[FxIdDomainSettingsPublicWebClientConfigOptionsDiagType["NUMBER_unknown_default_open_api"] = 11184809] = "NUMBER_unknown_default_open_api";
})(FxIdDomainSettingsPublicWebClientConfigOptionsDiagType || (FxIdDomainSettingsPublicWebClientConfigOptionsDiagType = {}));
export function instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsDiagType(value) {
    for (const key in FxIdDomainSettingsPublicWebClientConfigOptionsDiagType) {
        if (Object.prototype.hasOwnProperty.call(FxIdDomainSettingsPublicWebClientConfigOptionsDiagType, key)) {
            if (FxIdDomainSettingsPublicWebClientConfigOptionsDiagType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsDiagTypeFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsDiagTypeFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsDiagTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsDiagTypeToJSON(value) {
    return value;
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsDiagTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsDiagType.js.map